import * as React from "react";
import { isMobile, isWeixin, notChromeMessage } from "@/util";
import styled from "styled-components";
import { APKNAME } from "@/config/const";
const Container = styled.div`
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 45px;
  background-color: #ffa;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ChromeCheck: React.FC = () => {

  if (isMobile()) {
    return (
      <Container>
        <span>
          您好，移动端不支持浏览器模式，请下载APP使用
          <a
            href={`http://49.232.122.245:8012/latest/${APKNAME}`}
            target="_blank"
            rel="noreferrer"
          >
            安卓终端下载
          </a>
        </span>
      </Container>
    );
  }

  if (isWeixin()) {
    return (
      <Container>
        <span>
          您好，移动端不支持浏览器模式，请下载APP使用
          <a
            href={`http://49.232.122.245:8012/latest/${APKNAME}`}
            target="_blank"
            rel="noreferrer"
          >
            安卓终端下载,如果是IOS请联系管理员下载
          </a>
        </span>
      </Container>
    );
  }

  const browserErrorMessage = notChromeMessage();

  return browserErrorMessage ? (
    <Container>
      <span>{browserErrorMessage}</span>
    </Container>
  ) : (
    <></>
  );
};

export default ChromeCheck;
